const initializeProfilePaperDetailsTable = () => {
  $(".js-paper-details-toggle").on("click", function onToggleClick() {
    const element = $(this);
    element.toggleClass("active");
    $(element.data("details-container")).slideToggle();
  });
};
export default initializeProfilePaperDetailsTable;
